<script lang="ts">
import { defineComponent } from "vue";
import { defineAsyncComponent } from "vue";
import PoliticaIA from "./components/oferta/PoliticaIA.vue";


export default defineComponent({
    components: {
        InfoTresImagenes: defineAsyncComponent(() => import("./components/InfoTresImagenes.vue")), PoliticaIA
    },
    data() {
        return {
            showImage: true,
            isAnimating: false,
            videoUrl: "https://www.youtube.com/embed/bA3DNFmpeIs?si=J3d97hR3yZQHlF9y",
            img: "/pagesImages/mujer-modelo-ejecutivo-universidad-humanitas.webp",
            showImage2: true,
            videoUrl2: "https://www.youtube.com/embed/tWkEDcMN1Fo?si=jG0FXkuyIL6bDhxJ",
            img2: "/pagesImages/excelencia-academica-universidad-humanitas.webp",
            images: [
                { src: '/pagesImages/licenciaturas-BLANCO.webp', link: 'https://humanitas.edu.mx/licenciaturas', nombre: 'LICENCIATURAS', alt: 'Licenciaturas de Universidad Humanitas', describ: '' },
                { src: '/pagesImages/maestrias-BLANCO.webp', link: 'https://humanitas.edu.mx/maestrias', nombre: 'MAESTRÍAS', alt: 'Maestrías de Universidad Humanitas', describ: '' },
                { src: '/pagesImages/doctorados-BLANCO.webp', link: 'https://humanitas.edu.mx/doctorados', nombre: 'DOCTORADOS', alt: 'Doctorados de Universidad Humanitas', describ: '' },
            ],
        };
    },
    methods: {
        showVideo() {
        this.showImage = false;
        },
        showVideo2() {
        this.showImage2 = false;
        },
    },
    mounted() {
        setTimeout(() => {
            this.isAnimating = true; // Actualiza la propiedad después del delay
        }, 50);
    },
});
</script>

<template class="bg-white w-full">
    <section class="flex pt-[88px] lg:pt-[143px] justify-center items-center lg:mb-12 mb-16 w-full flex-col">
        <div class="flex items-center justify-center w-full bg-center bg-cover md:bg-[center-right] bg-no-repeat" style="background-image: url(/pagesImages/ejecutivo-banner.jpg)">
            <div class="flex justify-center w-full bg-white/40">
                <div class="flex text-justify w-full justify-center items-center max-w-4xl  lg:max-w-[1200px]">
                    <div :class="['w-full box items-end flex md:mb-56  my-8 md:my-0 md:mt-32 flex-col px-4', { 'visible': isAnimating }]">
                        <h1>
                            <span class="block font-normal text-right mb-0 text-[30px] text-hwine">Modelo</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block font-serif text-hwine text-[50px] mb-2">Ejecutivo</span>
                        </h1>
                        <p class="text-gray-800 text-right font-serif text-[19px]">
                        "La mejor forma de predecir el futuro es cre&aacute;ndolo".
                        </p>
                        <p class="text-gray-800 text-right"
                        >-Peter Drucker-</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="flex flex-col items-center w-full justify-center mb-16">
        <div class="flex w-full items-center justify-center">
            <div class="flex flex-col items-center w-full max-w-4xl lg:max-w-[1200px] px-4">
                <p class="font-serif md:text-[36px] text-3xl leading-tight text-hgold mb-8">
                Estudia una licenciatura <br class="md:block hidden" />
                sin detener lo que construyes
                </p>
                <div class="lg:flex items-center justify-center">
                    <div class="mt-4 text-justify ">
                        <p>
                            Sabemos que tienes trabajo, familia, proyectos y una vida que construyes. Por eso, en Universidad Humanitas creamos nuestro <b>Sistema Ejecutivo</b>, una forma flexible de estudiar pensada para quienes necesitan combinar su formación profesional con sus responsabilidades y su tiempo personal.<br><br>
                            A través de bloques especializados, avanzas de manera práctica y ordenada dentro de un programa con validez oficial de estudios. Y no lo haces solo: compartes con personas de experiencias diversas que enriquecen tu red profesional y personal.<br><br>
                            Además, incorporamos herramientas de <b>Inteligencia Artificial</b> para complementar tu aprendizaje, siempre conservando lo más importante: el sentido humano de la educación.<br><br>
                            Todo con costos accesibles y un sistema diseñado para aprovechar mejor tu tiempo.<br><br>
                        </p>
                        <p class="text-center mt-4">Trabaja. Estudia. Comparte. Crece.<br> <br><b>Universidad Humanitas. Cree en ti.</b></p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="flex flex-col items-center w-full justify-center mb-16">
        <div class="flex w-full items-center justify-center">
            <div class="flex flex-col items-center w-full max-w-4xl lg:max-w-[1200px] px-4">
                <p class="font-serif md:text-[36px] text-3xl leading-tight text-hgold mb-8">
                "Equilibro mi tiempo entre<br class="md:block hidden" />
                el trabajo, el estudio y mi familia."
                </p>
                <div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-10 lg:mb-0 lg:mr-12">
                        <h2 class="mt-4 mb-2 text-lg uppercase text-hgold">Planes de estudio</h2>
                        <p>
                            Nuestros planes de estudio cuentan con el reconocimiento oficial de la Secretaría de Educación Pública (SEP). Los programas son diseñados por especialistas en cada área y supervisados por el consejo académico.
                        </p>
                        <br />
                        <h2 class="mt-4 mb-2 text-lg uppercase text-hgold">Sistema por bloques</h2>
                        <p class="mb-4">
                            Universidad Humanitas es pionera en el Sistema por Bloques, un enfoque innovador que agrupa tres materias relacionadas dentro de una misma rama del programa de estudios, creando bloques especializados enfocados en áreas específicas.
                        </p>
                        <p>
                            Cada bloque es impartido por un profesor especialista, quien coordina los contenidos de las tres materias a lo largo de 10 sesiones del trimestre, con una sesión adicional dedicada a la evaluación final.
                        </p>
                    </div>
                    <div class="flex items-center justify-center">
                        <!-- <img src="/pagesImages/modelo-ejecutivo-hombre.webp" alt="Estudiante modelo ejecutivo Universidad Humanitas" /> -->
                        <VideoHiL :thumbnailUrl="'/pagesImages/modelo-ejecutivo-hombre-video.webp'" :alt="'Estudiante modelo ejecutivo Universidad Humanitas'" :videoUrl="'https://www.youtube.com/embed/Xr54EKe60js?si=CEKuRg-Zvhq3viHy'" class="w-full lg:max-w-[520px] cursor-pointer"/>
                    </div>
                </div>
            </div>
        </div>
    </section>
  <section class="flex items-center justify-center h-full w-full">
    <div
      class="flex items-center justify-center max-w-4xl lg:max-w-[1200px] bg-cover bg-[center] bg-no-repeat"
    >
      <div class="lg:flex justify-between items-center lg:mx-12">
        <div
          class="flex justify-between items-center lg:mb-0 mb-4"
        >
          <img :src="img"  :alt="'Mujer modelo ejecutivo Universidad Humanitas'" class="w-full lg:mr-12" />
        </div>
        <div class="flex justify-between lg:w-[52%] lg:mx-0 mx-2">
          <div class="flex flex-col text-[16px] text-justify text-gray-600 px-4">
            <h2>
                <span class="block text-left text-[28px]" style="">Metodología del</span>
                <span class="sr-only whitespace-nowrap">&nbsp;</span>
                <span class="block text-hgold text-left font-serif mb-8 text-[42px]">Sistema Ejecutivo</span>
            </h2>
            <ul class="list-disc pl-4 space-y-4">
              <li>Los programas se desarrollan en bloques trimestrales.</li>
              <li>
                Cada bloque de especialización fusiona tres materias y es impartido por un especialista en la materia.
              </li>
              <li>
                Las clases presenciales tienen una duración de tres horas por semana.
              </li>
              <li>
                Cada trimestre consta de 10 semanas de clases presenciales, una vez por semana, con una sesión adicional dedicada a la evaluación final.
              </li>
              <li>
                La evaluación final incluye la participación en clase, foros, trabajos y exámenes, lo que constituye el total de la calificación.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section
    class="flex justify-center items-center w-screen h-full lg:h-[600px] bg-cover lg:bg-center bg-no-repeat my-16"
    style="background-image: url(/pagesImages/mujer-familia-modelo-ejecutivo-universidad-humanitas.webp)"
  >
    <div class="lg:flex justify-between w-full max-w-4xl lg:max-w-[1200px] items-center">
      <div
        class="flex flex-col justify-start items-start lg:w-[45%] w-full lg:my-36 my-12 text-justify px-4"
      >
        <h2>
            <span class="block text-hwine text-left text-[28px]" style="">Perfil del</span>
            <span class="sr-only whitespace-nowrap">&nbsp;</span>
            <span class="block text-hwine text-left font-serif mb-6 text-[42px]">alumno ejecutivo</span>
        </h2>
        <div class="text-gray-800 text-base">
          <p class="pb-4">
            Los aspirantes al Modelo Ejecutivo son personas que comprenden la flexibilidad de este esquema y están dispuestas a gestionar su tiempo y compromisos para equilibrar trabajo y estudios.
          </p>
          <p class="pb-4">
            Tienen la autodisciplina necesaria para mantenerse motivados y enfocados en sus objetivos académicos.
          </p>
          <p>
            Están comprometidos con la oportunidad de combinar sus responsabilidades laborales con la búsqueda de una educación superior y tienen la seguridad de cumplir con éxito los requisitos del programa.
          </p>
        </div>
      </div>
    </div>
  </section>

  <!-- <section class="flex flex-col w-full items-center mb-12">
    <div class="px-4 mb-8">
      <h2 class="font-serif text-hgold text-[42px] mb-8">
        Nuestra Oferta Acad&eacute;mica
      </h2>
      <p class="text-lg">
        "Un hombre sabio se buscar&aacute; m&aacute;s oportunidades de las que se le
        presentan".
      </p>
      <div class="flex w-full justify-end items-center">
        <quote class="text-black font-times font-bold text-right italic"
          >-Francis Bacon-</quote
        >
      </div>
    </div>
    <div class="lg:flex items-center mt-8 gap-8 justify-center lg:mb-12 w-full max-w-4xl lg:max-w-[1200px]">
        <div v-for="(image, index) in images" :key="index" class="flex items-center justify-center lg:m-0 m-4 max-w-4xl  lg:max-w-[1200px]">
            <InfoTresImagenes :img="image.src" :titulo="image.nombre" :alt="image.alt" :enlace="image.link" :descrip="image.describ"  />
        </div>
    </div>
  </section> -->

  <section
    class="lg:flex items-center w-full justify-center bg-cover bg-[center] bg-no-repeat mb-16"
    style="
      background-image: url(/pagesImages/modelo-ejec-respon.jpg);
      position: relative;
      background-attachment: fixed;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      overflow: hidden;
      transition: transform 0.3s ease;
    "
  >
    <div class="flex justify-center  w-full" style="background-color: rgb(255 255 255 / 0.7);">
      <div class="lg:flex justify-center items-center lg:my-12 my-16 max-w-[1200px] w-full">
        <div class="flex items-center justify-center">
          <img
            :src="'/pagesImages/modelo-ejecutivo-graduado.webp'"
            :alt="'Excelencia académica en Universidad Humanitas'"
           class="lg:mr-12 lg:mb-0 mb-8 lg:px-0 px-4 lg:max-w-[520px]"
          />
        </div>
        <div class=" px-4 lg:px-0">
            <div class="text-center lg:text-left">
                <h2>
                    <span class="block text-hwine leading-none text-[28px] font-montse">Excelencia</span>
                    <span class="sr-only whitespace-nowrap">&nbsp;</span>
                    <span class="block text-hwine mb-4 font-serif text-[42px]">Acad&eacute;mica</span>
                </h2>
            </div>
            <p class="text-justify text-gray-800 mb-4">
                En Universidad Humanitas, la excelencia académica es nuestro compromiso fundamental. Ofrecemos programas de alta calidad diseñados por expertos, que fomentan el pensamiento crítico, la creatividad y la innovación, preparando a nuestros estudiantes para enfrentar los desafíos del mundo profesional.
            </p>
            <p class="text-justify text-gray-800 mb-4">
                Nuestro cuerpo docente altamente calificado acompaña a los estudiantes en su desarrollo académico y personal, creando un entorno propicio para el crecimiento. Fomentamos el aprendizaje colaborativo y la creación de redes profesionales, abriendo oportunidades para el futuro.
            </p>
            <p class="text-justify text-gray-800 ">
                Formamos no solo profesionales de excelencia, sino también seres humanos comprometidos con su entorno, convencidos de que la educación es la clave para transformar el futuro.
            </p>
        </div>
      </div>
    </div>
  </section>

  <PoliticaIA />

  <!-- <EgresadosHuma class="mb-12" />

  <section class="flex items-center justify-center w-full">
    <div
      class="lg:flex justify-start w-full max-w-4xl lg:max-w-[1200px] items-center mb-12"
    >
      <div class="flex items-center justify-center">
        <img src="/pagesImages/vive-eje.jpg" loading="lazy" alt="Humanitas Vive" />
      </div>
      <div class="flex flex-col lg:w-[50%] items-center text-justify lg:ml-12">
        <div class="mb-8 text-justify px-4">
          <div class="text-center lg:text-left w-full mt-6 lg:mt-0">
            <h2>
                <span class="block text-gray-700 mb-0 leading-tight font-normal text-[28px]">Programa</span>
                <span class="sr-only whitespace-nowrap">&nbsp;</span>
                <span class="block text-hgold mt-0 leading-tight font-serif text-[42px]">Humanitas Vive</span>
            </h2>
          </div>
          <br />
          <p>
            Es un programa de voluntariado en el cual las acciones y actividades
            est&aacute;n orientadas a la responsabilidad social de Universidad Humanitas,
            mediante el cual los alumnos pueden liberar su servicio social.
          </p>
          <br />
          <p>Estas actividades pueden ser:</p>
          <br />
          <p class="pl-2">• Sociales</p>
          <p class="pl-2">• Culturales</p>
          <p class="pl-2">• De altruismo</p>
          <p class="pl-2">• Deportivas</p>
          <p class="pl-2">• Ambientales</p>
          <br />
          <p>
            Humanitas Vive trabaja con instituciones autorizadas a las cuales se les
            brinda ayuda mediante donativos (sea en especie o en dinero) o mediante la
            organizaci&oacute;n de alguna actividad que vaya acorde con su ramo.
          </p>
        </div>
      </div>
    </div>
  </section> -->
</template>

<style scoped>
.box {
    transform: translateX(110%); /* Fuera del viewport */
    transition: transform 1.35s ease-in-out;
}

.box.visible {
    transform: translateX(0); /* Posición original */
}
</style>
